// URL/content-type detection for the lesson ContentViewer. Extracted to keep
// content-viewer.tsx within the component LOC limit (ENG-LOC-01).

export type ContentType = 'youtube' | 'vimeo' | 'video' | 'pdf' | 'image' | 'office' | 'unknown';

export function detectContentType(url: string): ContentType {
  if (/youtube\.com|youtu\.be/i.test(url)) return 'youtube';
  if (/vimeo\.com/i.test(url)) return 'vimeo';
  if (/\.(mp4|webm|ogg)(\?|$)/i.test(url)) return 'video';
  if (/\.pdf(\?|$)/i.test(url)) return 'pdf';
  // Mismos formatos de imagen que acepta la subida de archivos de lección.
  if (/\.(jpe?g|png|webp)(\?|$)/i.test(url)) return 'image';
  if (/\.(pptx?|docx?|xlsx?)(\?|$)/i.test(url)) return 'office';
  return 'unknown';
}

export function toEmbedUrl(url: string, type: ContentType): string {
  if (type === 'youtube') {
    const match = url.match(/(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    if (!match) return url;
    const origin = encodeURIComponent(window.location.origin);
    return `https://www.youtube.com/embed/${match[1]}?origin=${origin}&rel=0&enablejsapi=1`;
  }
  if (type === 'vimeo') {
    const match = url.match(/vimeo\.com\/(\d+)/);
    return match ? `https://player.vimeo.com/video/${match[1]}` : url;
  }
  return url;
}
